var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-nuo-container" },
    [
      !_vm.isChoosed
        ? _c(
            "div",
            {
              staticClass: "seal",
              class: _vm.elecsealClassArr,
              on: { click: _vm.chooseSeal },
            },
            [
              _c("span", { staticClass: "sealIcon" }, [_vm._v("+")]),
              _vm._v(" "),
              _c("span", [_vm._v("添加印章")]),
              _vm._v(" "),
              _vm.loading
                ? _c("van-loading", {
                    staticClass: "upload-seal",
                    attrs: { color: "#1989fa", type: "spinner" },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "choose-seal",
              class: _vm.elecsealClassArr,
              style: {
                left: _vm.posX ? _vm.posX + "px" : 0,
                top: _vm.posY ? _vm.posY + "px" : 0,
              },
              on: { click: _vm.chooseSeal },
            },
            [
              _c("img", {
                staticClass: "choose-seal-img",
                attrs: {
                  src: _vm.seal.downloadUrl
                    ? _vm.seal.downloadUrl
                    : _vm.seal.sealBase64,
                },
                on: { touchmove: _vm.onmove },
              }),
            ]
          ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          style: _vm.levelStyle,
          attrs: {
            position: "right",
            "close-on-click-overlay": false,
            "overlay-style": { "background-color": "rgba(0,0,0,.5)" },
            "get-container": _vm.getContainer,
          },
          model: {
            value: _vm.showList,
            callback: function ($$v) {
              _vm.showList = $$v
            },
            expression: "showList",
          },
        },
        [
          _vm.showList
            ? _c("seal-list-m", {
                ref: "sealListM",
                attrs: { sealConfigData: _vm.sealConfigData },
                on: {
                  "on-go-back": _vm.goBack,
                  "choose-seal": _vm.handelConfirm,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          style: { height: "22%" },
          attrs: { position: "bottom", "close-on-click-overlay": false },
          model: {
            value: _vm.showDelete,
            callback: function ($$v) {
              _vm.showDelete = $$v
            },
            expression: "showDelete",
          },
        },
        [
          _c("div", { staticClass: "del-btns" }, [
            _c(
              "div",
              { staticClass: "del-btns-top" },
              [
                _vm.canDelete
                  ? _c(
                      "div",
                      {
                        staticClass: "btn-common",
                        on: { click: _vm.handelBtnDelete },
                      },
                      [_vm._v("删除")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("van-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-common",
                    on: { click: _vm.chooseSealAgain },
                  },
                  [_vm._v("重新选择")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "del-btns-bottom btn-common",
                on: { click: _vm.handelBtnClose },
              },
              [_vm._v("取消")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }